export default "__VITE_ASSET__B7oKGUc1__"